import { render, staticRenderFns } from "./splccom.vue?vue&type=template&id=3e1a7774&scoped=true&"
import script from "./splccom.vue?vue&type=script&lang=js&"
export * from "./splccom.vue?vue&type=script&lang=js&"
import style0 from "./splccom.vue?vue&type=style&index=0&id=3e1a7774&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1a7774",
  null
  
)

export default component.exports